<h3 mat-dialog-title>{{'contentTypes.schemaItemValidator' | translate}}</h3>
<mat-dialog-content>
  <section class="validator-dialog-intro">
    <span>{{getValidatorLabel()}}</span>
    <p>{{getValidatorDescription()}}</p>
  </section>

  <form [formGroup]="validatorForm" class="m-1 validator-form">
    @if (type === 'textLength' || type === 'dateRange' || type === 'numericRange' || type === 'arrayLength') {
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{getMinLabel()}}</mat-label>
        <input matInput formControlName="min" [attr.min]="type === 'arrayLength' ? 0 : null" [attr.step]="type === 'arrayLength' ? 1 : null" [placeholder]="getMinPlaceholder()" type="number">
        <mat-hint>{{getMinHint()}}</mat-hint>
      </mat-form-field>
    }

    @if (type === 'textLength'  || type === 'dateRange' || type === 'numericRange' || type === 'arrayLength') {
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{getMaxLabel()}}</mat-label>
        <input matInput formControlName="max" [attr.min]="type === 'arrayLength' ? 0 : null" [attr.step]="type === 'arrayLength' ? 1 : null" [placeholder]="getMaxPlaceholder()" type="number">
        <mat-hint>{{getMaxHint()}}</mat-hint>
      </mat-form-field>
    }

    @if (type === 'numericEnum' ) {
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{'contentTypes.schemaRuleLabels.numericEnum' | translate}}</mat-label>
        <textarea matInput formControlName="values"></textarea>
        <mat-hint>{{'contentTypes.schemaAllowedValuesHint' | translate}}</mat-hint>
      </mat-form-field>
    }

    @if (type === 'textEnum' ) {
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{'contentTypes.schemaRuleLabels.textEnum' | translate}}</mat-label>
        <textarea matInput formControlName="values" [placeholder]="'contentTypes.schemaTextValuesExample' | translate"></textarea>
        <mat-hint>{{'contentTypes.schemaAllowedValuesHint' | translate}}</mat-hint>
      </mat-form-field>
    }

    @if (type === 'textRegex') {
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{'contentTypes.schemaUserHint' | translate}}</mat-label>
        <input matInput formControlName="hint" [placeholder]="'contentTypes.schemaUserHintExample' | translate" type="text">
        <mat-hint>{{'contentTypes.schemaUserHintDescription' | translate}}</mat-hint>
      </mat-form-field>
    }

    @if (type === 'textRegex') {
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{'contentTypes.schemaRuleLabels.textRegex' | translate}}</mat-label>
        <input matInput formControlName="regex" placeholder="^[A-Z]{3}-[0-9]{3}$" type="text">
        <mat-hint>{{'contentTypes.schemaRegexHint' | translate}}</mat-hint>
      </mat-form-field>
    }

    @if (type === 'dateRange') {
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{'taskTemplates.rules.minDaysAgo' | translate}}</mat-label>
        <textarea matInput formControlName="minDaysAgo" placeholder="30"></textarea>
        <mat-hint>{{'contentTypes.schemaMinDaysAgoHint' | translate}}</mat-hint>
      </mat-form-field>
    }

    @if (type === 'numericRange') {
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{'taskTemplates.rules.multipleOf' | translate}}</mat-label>
        <input matInput formControlName="multipleOf" placeholder="5" type="number">
        <mat-hint>{{'contentTypes.schemaMultipleOfHint' | translate}}</mat-hint>
      </mat-form-field>
    }

    @if (type=='numericRange') {
      <div class="form-control mb-1 d-flex justify-content-between">
        <label for="value">{{'taskTemplates.rules.maxExclusive' | translate}}</label>
        <mat-slide-toggle class="example-margin" formControlName="maxExclusive" ></mat-slide-toggle>
      </div>
    }

    @if (type=='numericRange') {
      <div class="form-control mb-1 d-flex justify-content-between">
        <label for="value">{{'taskTemplates.rules.decimal' | translate}}</label>
        <mat-slide-toggle class="example-margin" formControlName="decimal" ></mat-slide-toggle>
      </div>
    }

    @if (type=='numericRange') {
      <div class="form-control mb-1 d-flex justify-content-between">
        <label for="value">{{'taskTemplates.rules.minExclusive' | translate}}</label>
        <mat-slide-toggle class="example-margin" formControlName="minExclusive" ></mat-slide-toggle>
      </div>
    }

    @if (type=='textEMail') {
      <div class="form-control mb-1 d-flex justify-content-between">
        <label for="value">{{'taskTemplates.rules.lowercase' | translate}}</label>
        <mat-slide-toggle class="example-margin" formControlName="lowercase" ></mat-slide-toggle>
      </div>
    }

    @if (type=='textFormat') {
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>{{'taskTemplates.rules.format' | translate}} </mat-label>
        <mat-select formControlName="format" class="input-group">
          @for (option of formatoptions; track option; let index = $index) {
            <mat-option value="{{option}}"> {{option}}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  </form>
  @if (validationErrorKey; as errorKey) {
    <p class="validator-error" role="alert">{{errorKey | translate}}</p>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button style="color:var(--warmOrange);" (click)="onCancel();">{{'cancel' | translate}}</button>
  <button mat-button class="orange-button" (click)="onSave();" [disabled]="validatorForm.invalid || !!validationErrorKey" data-nar="content-type-schema-save">{{'save' | translate}}</button>
</mat-dialog-actions>
